import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

export const unselectableComponents = [
    // 'LAMP_22_DIA_GREEN',
    // 'LAMP_22_DIA_RED',
    // 'LAMP_22_DIA_AMBER',
    'Solid0370',
    'Shell',
    'SOLID_',
    'TH00104XXXX_1',
    'TH00097XXXX_',
    'C_TJ72435B22F',
    'C_TJ72684XXXX',
    'TH34233P632001',
    'V350-J_MFM',
    'SLANT_HEADER',
    'CM59081',
    'E-PLATE',
    'MESHES',
    'meshes',
    'HANDLE',
    'TOP_PLATE',
    'BRAND',
    'HRD',
    'PLINTH',
    'TRAY'
  ];
export const lightThemeStyles = {
    cardStyle: {
      marginBottom: 0.5,
      border: '1px solid var(--brand-color-1)',
      borderRadius: '2px',
      paddingRight: 1,
      paddingLeft: 1,
      backgroundColor: '#efefef', // Updated for light theme
      color: 'black',
      overflowY: 'auto',
    },
    titleStyle: {
      color: 'black',
      fontSize: '20px',
      fontWeight: '700',
      fontFamily: 'Roboto',
    },
    subtitleStyle: {
      color: 'black',
      fontSize: '16px',
      fontWeight: '500',
      fontFamily: 'Roboto',
    },
    bodyTextStyle: {
      color: 'black',
      fontSize: '14px',
      fontWeight: '400',
      fontFamily: 'Roboto',
    },
  };
  
export const darkThemeStyles = {
    cardStyle: {
      marginBottom: 0.5,
      border: '1px solid var(--brand-color-1)',
      borderRadius: '2px',
      paddingRight: 1,
      paddingLeft: 1,
      backgroundColor: '#000000', // Updated for dark theme
      color: 'var(--primary-text)',
      overflowY: 'auto',
    },
    titleStyle: {
      color: 'var(--highlighted-text-1)',
      fontSize: '20px',
      fontWeight: '700',
      fontFamily: 'Roboto',
    },
    subtitleStyle: {
      color: 'var(--secondary-text)',
      fontSize: '16px',
      fontWeight: '500',
      fontFamily: 'Roboto',
    },
    bodyTextStyle: {
      color: 'var(--primary-text)',
      fontSize: '14px',
      fontWeight: '400',
      fontFamily: 'Roboto',
    },
  };
  // Example data series
export  const temperatureTrendSeries = [
    {
      name: 'HBB R',
      data: [
        { x: new Date('2025-02-18').getTime(), y: 35 },
        { x: new Date('2025-02-19').getTime(), y: 31 },
        { x: new Date('2025-02-20').getTime(), y: 29 },
        { x: new Date('2025-02-21').getTime(), y: 33 },
        { x: new Date('2025-02-22').getTime(), y: 34 },
      ],
    },
    {
      name: 'HBB Y',
      data: [
        { x: new Date('2025-02-18').getTime(), y: 38 },
        { x: new Date('2025-02-19').getTime(), y: 39 },
        { x: new Date('2025-02-20').getTime(), y: 30 },
        { x: new Date('2025-02-21').getTime(), y: 31 },
        { x: new Date('2025-02-22').getTime(), y: 32 },
      ],
    },
    {
      name: 'HBB B',
      data: [
        { x: new Date('2025-02-18').getTime(), y: 26 },
        { x: new Date('2025-02-19').getTime(), y: 27 },
        { x: new Date('2025-02-20').getTime(), y: 28 },
        { x: new Date('2025-02-21').getTime(), y: 29 },
        { x: new Date('2025-02-22').getTime(), y: 30 },
      ],
    },
  ];

export const voltageData = [
  { label: 'L1 ', key: 'rmsVoltage1' },
  { label: 'L2 ', key: 'rmsVoltage2' },
  { label: 'L3 ', key: 'rmsVoltage3' },
  { label: 'Average', key: 'averageVoltage' }
];

export const currentData = [
  { label: 'RMS R', key: 'rmsCurrent1' },
  { label: 'RMS Y', key: 'rmsCurrent2' },
  { label: 'RMS B', key: 'rmsCurrent3' },
  { label: 'THD R Phase Current', key: 'thdRPhaseCurrent' },
  { label: 'THD Y Phase Current', key: 'thdYPhaseCurrent' },
  { label: 'THD B Phase Current', key: 'thdBPhaseCurrent' }
];

export const componentInfoDefaults = [
  { label: 'Motor Voltage', key: 'motorVoltage', defaultValue: '389.40 V' },
  { label: 'DC Link Voltage', key: 'dcLinkVoltage', defaultValue: '400.30 V' },
  { label: 'Current', key: 'current', defaultValue: '0.00 A' },
  { label: 'Power', key: 'power', defaultValue: '0.00 kW' },
  { label: 'Frequency', key: 'frequency', defaultValue: '50.00 Hz' },
  { label: 'Power Factor', key: 'powerFactor', defaultValue: '0.98' }
];

export const initialFormState = {
  // Required Fields
  breaker: "8", // Maps to "8" in API
  current_y: "2500",
  panelHeight: "2.1",
  panelWidth: "0.8",
  panelDepth: "0.8",
  ambient: "32.2",
  
  // Optional Fields with example defaults
  month: "",
  latitude: "",
  panelColor: "",
  panelOrientation: "",
  solarToggle: "",
  solarEnv: "",
  coveredSurfaces: ["Bottom"], // bottom: true, all others false
  linksPerPole: "4",
  linkWidth: "0.1",
  linkThickness: "0.005",
  crossSection: "2000e-6", // 2000e-6
  insulationThickness: "0.0005",
  spreaderThickness: "0",
  upperTempLimit: "100",
  links_total_length: "8.7", // Same as linkLength to avoid mismatch
  numPartitions: "0",
  numBreakers: "1",
  breakerDistribution: "Equally spaced", // Maps to 0 via distributionMap
  topBreakerHeight: "0",
  breakerGap: "0",
  additionalPower: "0",
  breakerPositionTop: "1",
  ventArea: "",
  cfm: "",
  ipRating: "IP5X",
  current_cl: "2500",
  hotResistivity: "2.26e-8", // 2.26e-8
  linkLength: "2.9",
  spreaderUsed: false,
  altitude: "",
  
  // Additional fields for form functionality
  current_r: "2500",
  current_b: "2500",
  openAirTR_top_r: "",
  openAirTR_top_y0: "56.1",
  openAirTR_top_y: "56.1",
  openAirTR_top_b: "56.1",
  busbar: "Copper",
  linkType: "Rectangle",
  currentInLinks: "",
  installation: "",
  ventilation: "",
  date: "",
  time: "",
};

export const breakerTypes = [
  { value: "1", label: "ACB: Fr1_400-1250A N" },
  { value: "2", label: "ACB: Fr1_1600A N (V+V)" },
  { value: "3", label: "ACB: Fr1_1600A S (V+V)" },
  { value: "4", label: "ACB: Fr1_2000A N (V+V)" },
  { value: "5", label: "ACB: Fr1_2000A S (V+V)" },
  { value: "6", label: "ACB: Fr1_2500A S & 400-2500A H (V+V)" },
  { value: "7", label: "ACB: Fr2_400-2500A N/S (V+V)" },
  { value: "8", label: "ACB: Fr2_3200A S & 400-3200A H (V+V)" },
  { value: "9", label: "ACB: Fr2_3200A S & 400-3200A H (H+V)" },
  { value: "10", label: "ACB: Fr2_3200A S & 400-3200A H (H+H)" },
  { value: "11", label: "ACB: Fr2_4000A S/H (H+V)" },
  { value: "12", label: "ACB: Fr2_4000A S/H (V+V)" },
  { value: "13", label: "ACB: Fr3_400-4000A H/V (V+V)" },
  { value: "14", label: "ACB: Fr3_400-4000A H/V (H+V)" },
  { value: "15", label: "ACB: Fr3_5000A H/V (V+V)" },
  { value: "16", label: "ACB: Fr3_6300A H/V (V+V)" },
  { value: "17", label: "MCCB: Fr6_400A" },
  { value: "18", label: "MCCB: Fr7_630A" },
  { value: "19", label: "MCCB: Fr7_800A" }
];

export const textFieldProperties = [
  { id: "current_r", label: "R Phase Current (A)", type: "number" },
  { id: "current_y", label: "Y Phase Current (A) *", type: "number", required: true },
  { id: "current_b", label: "B Phase Current (A)", type: "number" },
  { id: "ambient", label: "Ambient Temperature (°C) *", type: "number", required: true },
  { id: "openAirTR_top_r", label: "Open Air TR (°C) - R Phase", type: "number" },
  { id: "openAirTR_top_y", label: "Open Air TR (°C) - Y Phase", type: "number" },
  { id: "openAirTR_top_b", label: "Open Air TR (°C) - B Phase", type: "number" },
  { id: "upperTempLimit", label: "Upper Temperature Limit (°C)", type: "number" },
];

export const linkMaterialOptions = [
  { value: "", label: "-- Select Material --" },
  { value: "Copper", label: "Copper" },
  { value: "Aluminium", label: "Aluminium" },
];

export const linkConfigTextFieldProperties = [
  { id: "linksPerPole", label: "Links/Cables per Pole", type: "number" },
  { id: "hotResistivity", label: "Link/Cable Hot Resistivity (Ω·m)", type: "text" },
  { id: "linkLength", label: "Link/Cable Length (m)", type: "text" },
  { id: "crossSection", label: "Link/Cable Cross Section (m²)", type: "text" },
  { id: "linkWidth", label: "Link Width (m)", type: "number" },
  { id: "linkThickness", label: "Link Thickness (m)", type: "number" },
  { id: "insulationThickness", label: "Insulation Thickness (m)", type: "number" },
  { id: "current_cl", label: "Current in Links/Cables (A)", type: "number" },
];

export const panelConfigTextFieldProperties = [
  { id: "panelHeight", label: "Panel Height (m) *", type: "number", required: true },
  { id: "panelWidth", label: "Panel Width (m) *", type: "number", required: true },
  { id: "panelDepth", label: "Panel Depth (m) *", type: "number", required: true },
  { id: "numPartitions", label: "Horizontal Partitions", type: "number" },
  { id: "links_total_length", label: "Total Length of links per pole", type: "number" },
  { id: "currentInLinks", label: "Current in Links/Cables (A)", type: "number" },
];

export const installationTypeOptions = [
  { value: "Type 1 - Separate enclosure, detached on all sides", label: "Type 1 - Separate enclosure, detached on all sides" },
  { value: "Type 2 - First or Last enclosure, detached type", label: "Type 2 - First or Last enclosure, detached type" },
  { value: "Type 3 - Separate enclosure, wall mounting", label: "Type 3 - Separate enclosure, wall mounting" },
  { value: "Type 3 - Central enclosure, detached type", label: "Type 3 - Central enclosure, detached type" },
  { value: "Type 4 - First or last enclosure wall mounting type", label: "Type 4 - First or last enclosure wall mounting type" },
  { value: "Type 5 - First or last enclosure wall mounting type", label: "Type 5 - First or last enclosure wall mounting type" },
  { value: "Type 5 - Central enclosure, wall mounting type & top surfaces covered", label: "Type 5 - Central enclosure, wall mounting type & top surfaces covered" },
];

export const ipRatingOptions = [
  { value: "IP4X", label: "IP4X" },
  { value: "IP5X", label: "IP5X" },
  { value: "Fan Cooling", label: "Fan Cooling" },
];

export const monthOptions = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

export const panelColorOptions = [
  { value: "White(metal)", label: "White(metal)" },
  { value: "Cream(metal)", label: "Cream(metal)" },
  { value: "Yellow(metal)", label: "Yellow(metal)" },
  { value: "Light:Grey,blue,green(metal)", label: "Light:Grey,blue,green(metal)" },
  { value: "Medium:Grey,blue,green(metal)", label: "Medium:Grey,blue,green(metal)" },
  { value: "Dark:Grey,blue,green(metal)", label: "Dark:Grey,blue,green(metal)" },
  { value: "Black(metal)", label: "Black(metal)" },
  { value: "Light(Plastic)", label: "Light(Plastic)" },
  { value: "Medium(Plastic)", label: "Medium(Plastic)" },
  { value: "Dark(Plastic)", label: "Dark(Plastic)" },
];

export const panelOrientationOptions = [
  { value: "South", label: "South" },
  { value: "North", label: "North" },
  { value: "East", label: "East" },
  { value: "West", label: "West" },
];

// ── Layer assignments for 3D scene visibility ──────────────────────────────
export const layerAssignments = {
  _1f3: 'layerA',
  _1f1: 'layerB',
  _2f2: 'layerA',
  _2f4: 'layerC',
  node5: 'layerB',
};

// ── Temperature trend chart options ─────────────────────────────────────────
export const temperatureTrendOptions = {
  chart: {
    type: 'line',
    toolbar: { show: false },
    zoom: { enabled: false },
  },
  stroke: { curve: 'smooth', width: 1.5 },
  grid: { show: true, borderColor: 'var(--grey-variation)' },
  xaxis: {
    type: 'datetime',
    labels: {
      show: true,
      style: { colors: 'var(--axis-color)', fontSize: '12px', fontFamily: 'Roboto', fontWeight: 800 },
      formatter: function (value) {
        if (isNaN(value)) return '';
        return new Date(value).toLocaleDateString('en-us', { month: 'short', day: 'numeric' });
      },
    },
    axisBorder: { show: true, color: 'var(--axis-color)' },
    axisTicks: { show: true, height: 3, color: 'var(--axis-color)' },
  },
  yaxis: {
    title: {
      text: 'Temperature (°C)',
      style: { color: 'var(--axis-title-color)', fontSize: '12px', fontFamily: 'Roboto', fontWeight: 800 },
    },
    labels: {
      style: { colors: 'var(--axis-color)', fontSize: '12px', fontFamily: 'Roboto', fontWeight: 800 },
      formatter: (value) => value?.toFixed(2),
    },
  },
  markers: { radius: 12, height: '10px', width: '10px' },
  tooltip: {
    enabled: true,
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      const timestamp = w.globals.seriesX[seriesIndex][dataPointIndex];
      const formattedDate = new Date(timestamp)
        .toLocaleDateString('en-US', {
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hour12: false,
        })
        .replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g, '$3-$1-$2');
      let html = `<div style="display:flex;flex-direction:column;padding:5px;">`;
      html += `<div style="font-weight:600;color:#FFFFFF;">${formattedDate}</div>`;
      for (let i = 0; i < series.length; i++) {
        const val = series[i][dataPointIndex];
        html += `<div style="display:flex;align-items:center;margin-bottom:4px;">
          <div style="height:8px;width:8px;background-color:${w.config.colors[i]};border-radius:50%;margin-right:8px;"></div>
          <div style="font-weight:600;color:${w.config.colors[i]};">${w.config.series[i].name}</div>
          <div style="margin-left:12px;color:${w.config.colors[i]};">${val?.toFixed(2)}</div>
        </div>`;
      }
      html += `</div>`;
      return html;
    },
  },
  colors: ['#FF5733', '#FFD000', '#008CD7'],
  states: { hover: { filter: { type: 'none' } } },
};

// ── Tag ID to component-property mapping ────────────────────────────────────
export const componentDataTagId = {
  _1f1: {
    temperatureSensor1: { tagid: '3315110', data: '' },
    temperatureSensor2: { tagid: '3315111', data: '' },
    temperatureSensor3: { tagid: '3315112', data: '' },
    temperatureSensor4: { tagid: '3315113', data: '' },
    temperatureSensor5: { tagid: '3315114', data: '' },
    temperatureSensor6: { tagid: '3315115', data: '' },
    temperatureSensor7: { tagid: '3315116', data: '' },
    temperatureSensor8: { tagid: '3315117', data: '' },
  },
  _1f3: {
    frame: { tagid: '3830680', data: '' },
    iframe: { tagid: '3830681', data: '' },
    rating: { tagid: '3830682', data: '' },
    poles: { tagid: '3830683', data: '' },
    ir: { tagid: '3830684', data: '' },
    iy: { tagid: '3830685', data: '' },
    ib: { tagid: '3830686', data: '' },
    in: { tagid: '3830687', data: '' },
    ig: { tagid: '3830688', data: '' },
    vr: { tagid: '3830689', data: '' },
    vy: { tagid: '38306810', data: '' },
    vb: { tagid: '38306811', data: '' },
    vry: { tagid: '38306812', data: '' },
    vyb: { tagid: '38306813', data: '' },
    vbr: { tagid: '38306814', data: '' },
    totalActiveEnergy: { tagid: '38306815', data: '' },
    totalReactiveEnergy: { tagid: '38306816', data: '' },
    totalApparentEnergy: { tagid: '38306817', data: '' },
    contactWearR: { tagid: '38306818', data: '' },
    contactWearY: { tagid: '38306819', data: '' },
    contactWearB: { tagid: '38306820', data: '' },
    contactWearN: { tagid: '38306821', data: '' },
    incomerSideR: { tagid: '38306822', data: '' },
    incomerSideY: { tagid: '38306823', data: '' },
    incomerSideB: { tagid: '38306824', data: '' },
    incomerSideN: { tagid: '38306825', data: '' },
    loadSideR: { tagid: '38306826', data: '' },
    loadSideY: { tagid: '38306827', data: '' },
    loadSideB: { tagid: '38306828', data: '' },
    loadSideN: { tagid: '38306829', data: '' },
    faultCounterL: { tagid: '38306830', data: '' },
    faultCounterS: { tagid: '38306834', data: '' },
    faultCounterI: { tagid: '38306832', data: '' },
    faultCounterG: { tagid: '38306833', data: '' },
    faultCounterTripDueToETU: { tagid: '38306834', data: '' },
    onOperation: { tagid: '38306835', data: '' },
    offOperation: { tagid: '38306836', data: '' },
  },
  _2f2: {
    rmsVoltage1: { tagid: '9936590', data: '' },
    rmsVoltage2: { tagid: '9936591', data: '' },
    rmsVoltage3: { tagid: '9936592', data: '' },
    rmsCurrent1: { tagid: '9936593', data: '' },
    rmsCurrent2: { tagid: '9936594', data: '' },
    rmsCurrent3: { tagid: '9936595', data: '' },
    thdRPhaseCurrent: { tagid: '9936596', data: '' },
    thdYPhaseCurrent: { tagid: '9936597', data: '' },
    thdBPhaseCurrent: { tagid: '9936598', data: '' },
    thdRPhaseVoltage: { tagid: '9936599', data: '' },
    thdYPhaseVoltage: { tagid: '99365910', data: '' },
    thdBPhaseVoltage: { tagid: '99365911', data: '' },
  },
  _2f4: {
    vfdStatus: { tagid: '3691210', data: '' },
    motorVoltage: { tagid: '3691211', data: '0.00' },
    dcLinkVoltage: { tagid: '3691212', data: '' },
    current: { tagid: '3691213', data: '0.00' },
    power: { tagid: '3691214', data: '0.00' },
    frequency: { tagid: '3691215', data: '0.00' },
    powerFactor: { tagid: '3691216', data: '0.00' },
  },
};